import { ErrorIcon, ErrorMessage, Props, Wrapper } from "./InputFeedback.Parts";

export const InputFeedback = ({ message }: Props) => {
  if (typeof message !== "string") return null;

  return (
    <Wrapper>
      <ErrorIcon aria-hidden="true" />
      <ErrorMessage>{message}</ErrorMessage>
    </Wrapper>
  );
};
